import React from 'react';
import PropTypes from 'prop-types';
import { ToastContainer } from 'react-toastify';

import NavBar from '../navbar';
import { Outlet } from 'react-router-dom';

const Layout = ({ user, isEvisit, appSocket }) => {
	return (
		<div id="body">
			<header className="topnavbar-wrapper">
				<NavBar
					user={user}
					allowPolling={!user?.get('provider_practice')?.no_polling_ind}
					appSocket={appSocket}
				/>
			</header>
			{isEvisit ? (
				<Outlet />
			) : (
				<section>
					<div className="main-content">
						<Outlet />
					</div>
				</section>
			)}
			<div id="notification-wrapper" className="notification-wrapper">
				<ToastContainer position="top-center" autoClose={3000} />
			</div>
		</div>
	);
};

Layout.propTypes = {
	user: PropTypes.object.isRequired,
	isEvisit: PropTypes.bool,
	appSocket: PropTypes.object.isRequired,
};
export default Layout;
